import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { forkJoin } from "rxjs";

interface ModalDataI {
  completed: boolean;
  progress: number;
  error: string;
  isInProgress: boolean;
  isReady: boolean;
  hasFailed: boolean;
}

@Component({
  selector: "cradua-document-dialog",
  templateUrl: "./document-dialog.component.html",
  styleUrls: ["./document-dialog.component.scss"],
})
export class DocumentDialogComponent implements OnInit {
  @ViewChild("file", { static: false })
  file;

  public files: Set<File> = new Set();

  constructor(
    public dialogRef: MatDialogRef<DocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: ModalDataI,
  ) {}

  ngOnInit() {
    console.log(this.modalData);
  }

  // progress;
  // canBeClosed = true;
  // primaryButtonText = "Upload";
  // showCancelButton = true;
  // uploading = false;
  // uploadSuccessful = false;

  onFilesAdded() {
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        this.files.add(files[key]);
      }
    }
  }

  addFiles() {
    this.file.nativeElement.click();
  }

  closeDialog() {
    // if everything was uploaded already, just close the dialog
    // if (this.uploadSuccessful) {
    //   return this.dialogRef.close();
    // }

    // set the component state to "uploading"
    // this.uploading = true;

    this.dialogRef.close(this.files);

    this.dialogRef.disableClose = false;
    return;
    // // start the upload and save the progress map
    // // this.progress = this.uploadService.upload(this.files);
    // console.log(this.progress);
    // for (const key in this.progress) {
    //   this.progress[key].progress.subscribe((val) => console.log(val));
    // }

    // // convert the progress map into an array
    // let allProgressObservables = [];
    // for (let key in this.progress) {
    //   allProgressObservables.push(this.progress[key].progress);
    // }

    // // Adjust the state variables

    // // The OK-button should have the text "Finish" now
    // this.primaryButtonText = "Finish";

    // // The dialog should not be closed while uploading
    // this.canBeClosed = false;
    // this.dialogRef.disableClose = true;

    // // Hide the cancel-button
    // this.showCancelButton = false;

    // // When all progress-observables are completed...
    // forkJoin(allProgressObservables).subscribe((end) => {
    //   // ... the dialog can be closed again...
    //   this.canBeClosed = true;
    //   this.dialogRef.disableClose = false;

    //   // ... the upload was successful...
    //   this.uploadSuccessful = true;

    //   // ... and the component is no longer uploading
    //   this.uploading = false;
    // });
  }
}
